import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

function MobileKeyboardKey(props) {
  return <div className="xwordjs-keyboard-key" onClick={() => props.onClick(props.code)} onTouchEnd={(e) => {props.onClick(props.code); e.preventDefault()}}>{props.value}</div>;
}

class MobileKeyboard extends Component {

  render() {
    var keys = ["1234567890", "QWERTYUIOP", "ASDFGHJKL", "␣ZXCVBNM#⌫"];
    var rows = [];
    for (var i=0; i < keys.length; i++) {
      var rowstr = keys[i];
      var row_keys = [];
      for (var j=0; j < rowstr.length; j++) {
        var ch = rowstr.charAt(j);
        var code;
        if (ch === '␣') {
          code = 0x20;
        } else if (ch === '⌫') {
          code = 0x8;
        } else if (ch === '#') {
          code = 0x5;
        } else {
          code = ch.charCodeAt(0);
        }
        var key = <MobileKeyboardKey key={ch} onClick={this.props.onClick} code={code} value={ch}/>;
        row_keys.push(key);
      }

      var rowclass = "xwordjs-keyboard-row";
      if (i === 0 && !this.props.show_numeric_keys) {
        rowclass += " xwordjs-keyboard-row-numeric-hidden";
      }
      rows[i] = <div className={rowclass} key={i}>{row_keys}</div>;
    }

    var keyboard_class = "xwordjs-keyboard";
    if (!this.props.hidden) {
      keyboard_class += " xwordjs-keyboard-force-visible";
    }

    return (
      <div className={keyboard_class} onTouchEnd={(e) => e.preventDefault()}>
        {rows}
      </div>
    );
  }
}

const MobileKeyboardButton = (props) => (
  <Button className="xwordjs-submit-button xwordjs-keyboard-toggle" onClick={props.onClick} active={props.active} bsSize="xsmall"><i className="fa fa-keyboard-o"></i></Button>
);

export {MobileKeyboard, MobileKeyboardButton};



// WEBPACK FOOTER //
// ./src/MobileKeyboard.js